import React from 'react';
import { SmartHeaderWithCredits } from './SmartHeaderWithCredits';

interface AppLayoutProps {
  children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      <SmartHeaderWithCredits />
      {children}
    </div>
  );
}